module.exports = __webpack_public_path__ + "static/img/3.cd84bc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/3.png
// module id = Nyvm
// module chunks = 1